'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '@s7/base';
import { rem } from '@s7/styles';
import { Divider } from '@s7/ui';

const styles = (theme)=>({
        padding: `0 ${rem(24)}`,
        [theme.fn.up('md1')]: {
            padding: `0 ${rem(40)}`
        }
    });
const SearchLayoutDivider = ()=>{
    return /*#__PURE__*/ jsx(Box, {
        sx: styles,
        children: /*#__PURE__*/ jsx(Divider, {})
    });
};

export { SearchLayoutDivider };
//# sourceMappingURL=SearchLayoutDivider.js.map
